// Shared wording for pages that read the useOrgEndUsers slice instead of an
// aggregate count. Reaching the cap means the slice may be incomplete — it
// does NOT prove a next user exists, so this never claims a verified count.
export const ORG_END_USER_SLICE_LIMIT = 500;

export function sliceScopeNote(limitReached: boolean): string | null {
  if (!limitReached) return null;
  return `Showing the ${ORG_END_USER_SLICE_LIMIT} most recently created users. There may be more — this view does not include them.`;
}
